// extracted by mini-css-extract-plugin
export default {"input":"_2Hf-7TD7","label":"VD2M--7_"};